export { default as colors } from './colors.js';
export { default as fonts } from './fonts.js';
export { default as breakpoints } from './breakpoints.js';
export { default as scrollbars } from './scrollbars.js';

const fontBaseSize = 16;
export const p2r = v => `${v/fontBaseSize}rem`;
